
import { useDispatch, useSelector } from "react-redux";
import { Autocomplete, Box, TextField } from "@mui/material";
import MaterialTable from "material-table"
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { AddStudyProgramAction, UpdateStudyProgramAction, DeleteStudyProgramAction } from "../../../../../store/Ancillary/StudyProgram/Action";

const StudyProgram = () => {
    const dispatch = useDispatch()
    const { studyprogram_options } = useSelector(state => state?.AncillaryReducer?.StudyProgramReducer);
    const { studylevel_options } = useSelector(state => state?.AncillaryReducer?.StudyLevelReducer);
    return (
        <Box>
            <MaterialTable
                columns={[
                    {
                        title: "Study Level", cellStyle: { padding: "0px 10px" }, field: "studylevel", validate: rowData => {
                            if (rowData?.studylevel) {
                                return ''
                            } else {
                                return 'Study Level cannot be empty'
                            }
                        },
                        editComponent: props => {
                            return (
                                <Autocomplete
                                    defaultValue={{ name: props.rowData?.studylevel || "", id: props.rowData?.studylevel_id || "" }}
                                    id="studylevel_id"
                                    options={studylevel_options}
                                    onChange={(e, data) => { props.onChange(data) }}
                                    size="small"
                                    required={true}
                                    getOptionLabel={option => { return option?.name }}
                                    renderInput={(params) => <TextField size="small" {...params}
                                        variant="standard"
                                        label="Study Level"
                                        error={props?.error}
                                        helperText={props?.helperText} />}
                                />
                            )
                        }
                    },
                    {
                        title: "Program Name", cellStyle: { padding: "0px 10px" }, field: "name", validate: rowData => rowData?.name === '' || rowData?.name === undefined ? 'Name cannot be empty' : '',
                        editComponent: props => (
                            <TextField
                                required={true}
                                variant="standard"
                                value={props?.value}
                                onChange={e => props.onChange(e.target.value)}
                                error={props?.error}
                                helperText={props?.helperText}
                            />
                        )
                    },    
                ]}
                data={studyprogram_options || []}
                icons={{
                    Add: () => <AddIcon />,
                    Edit: () => <EditIcon />,
                    Delete: () => <DeleteIcon />
                }}
                editable={{
                    onRowAdd: (newRow) =>
                        new Promise((resolve, reject) => {
                            dispatch(AddStudyProgramAction(newRow))
                            setTimeout(() => resolve(), 500);
                        }),
                    onRowUpdate: (newRow, oldRow) =>
                        new Promise((resolve, reject) => {
                            dispatch(UpdateStudyProgramAction(newRow))
                            setTimeout(() => resolve(), 500);
                        }),
                    onRowDelete: (selectedRow) =>
                        new Promise((resolve, reject) => {
                            dispatch(DeleteStudyProgramAction({...selectedRow, studyprogram_id: `{${selectedRow?.studyprogram_id}}`}))
                            setTimeout(() => resolve(), 1000);
                        }),
                }}
                options={{
                    maxBodyHeight: 220,
                    rowStyle: { fontSize: "13px" },
                    headerStyle: { padding: "0px 10px", fontWeight: "bold" },
                    sorting: true,
                    search: false,
                    searchFieldAlignment: "right",
                    searchAutoFocus: true,
                    searchFieldVariant: "standard",
                    filtering: false,
                    paging: false,
                    selection: false,
                    actionsColumnIndex: -1,
                    grouping: false,
                    addRowPosition: "first",
                }}
                title=""
            />
        </Box>
    );
}
export default StudyProgram;